import { render, staticRenderFns } from "./GalleryPhotoEdit.vue?vue&type=template&id=282444ba"
import script from "./GalleryPhotoEdit.vue?vue&type=script&lang=js"
export * from "./GalleryPhotoEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports